<template>
  <ul class="software-list">
    <li v-for="software in value">
      <router-link
        class="software-wrapper"
        :to="software.href"
        v-if="software.href">
        <software-item :software="software">
        </software-item>
      </router-link>

      <div
        class="software-wrapper"
        v-else>
        <software-item :software="software">
        </software-item>
      </div>
    </li>
  </ul>
</template>

<script>
  import SoftwareItem from '../software-item';

  export default {
    name: 'software-list',

    components: { SoftwareItem },

    /**
     * @param {object[]} value - array of software
     * @param {number}   value[].id
     * @param {string}   value[].name
     * @param {string}   value[].iconUrl
     * @param {string}   value[].href - each software can be a link
     */
    props: ['value'],

    data() {
      return {};
    }
  }
</script>

<style lang="scss" scoped>
  ul {
    margin-top: 10px;

    > li {
      display: inline-block;
      vertical-align: top;

      > a:hover {
        background-color: #333333;
        text-decoration: none;
      }

      .software-wrapper {
        display: block;
        height: 100%;
        padding: 10px 5px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// index.vue?cbb58c8e